import {
  BarChart3,
  Building2,
  CalendarCheck2,
  CalendarDays,
  CalendarRange,
  ClipboardCheck,
  ClipboardList,
  Clock4,
  FileClock,
  FolderKanban,
  LayoutDashboard,
  ListChecks,
  ListTodo,
  Network,
  PlusCircle,
  Repeat,
  Settings,
  ShieldCheck,
  Store,
  Tags,
  TriangleAlert,
  UserCog,
  Users,
  BadgeCheck,
  ScrollText,
  type LucideIcon,
} from 'lucide-react';

export type ModuleId = 'hrms' | 'tasks';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Visible when the user has any of these permissions. */
  perms: string[];
  section?: string;
}

export const HRMS_NAV: NavItem[] = [
  { label: 'Dashboard', to: '/hrms/dashboard', icon: LayoutDashboard, perms: ['hrms_dashboard:view'] },
  { label: 'Employees', to: '/hrms/employees', icon: Users, perms: ['employees:view'], section: 'People' },
  { label: 'Departments', to: '/hrms/departments', icon: Building2, perms: ['departments:view'], section: 'People' },
  { label: 'Designations', to: '/hrms/designations', icon: BadgeCheck, perms: ['designations:view'], section: 'People' },
  { label: 'Teams & Managers', to: '/hrms/teams', icon: Network, perms: ['teams:view', 'manager_mappings:view'], section: 'People' },
  { label: 'Attendance & Hours', to: '/hrms/attendance', icon: Clock4, perms: ['attendance:view'], section: 'Time' },
  { label: 'Leave', to: '/hrms/leave', icon: CalendarCheck2, perms: ['leave:view'], section: 'Time' },
  { label: 'Regularisation', to: '/hrms/regularisations', icon: FileClock, perms: ['regularisations:view'], section: 'Time' },
  { label: 'Leave Policies & Types', to: '/hrms/leave-policies', icon: ClipboardCheck, perms: ['leave_policies:manage'], section: 'Configuration' },
  { label: 'Holidays', to: '/hrms/holidays', icon: CalendarDays, perms: ['holidays:view'], section: 'Configuration' },
  { label: 'Reports', to: '/hrms/reports', icon: BarChart3, perms: ['hrms_reports:view'], section: 'Insights' },
  { label: 'Roles & Permissions', to: '/hrms/roles', icon: ShieldCheck, perms: ['roles:view', 'roles:manage'], section: 'Administration' },
  { label: 'Settings', to: '/settings', icon: Settings, perms: ['settings:view'], section: 'Administration' },
  { label: 'Audit Logs', to: '/audit-logs', icon: ScrollText, perms: ['audit:view'], section: 'Administration' },
];

export const TASK_NAV: NavItem[] = [
  { label: 'Dashboard', to: '/tasks/dashboard', icon: LayoutDashboard, perms: ['task_dashboard:view'] },
  { label: 'My Tasks', to: '/tasks/my', icon: ListTodo, perms: ['tasks:view'], section: 'Work' },
  { label: 'All Tasks', to: '/tasks/list', icon: ClipboardList, perms: ['tasks:view'], section: 'Work' },
  { label: 'Create Task', to: '/tasks/new', icon: PlusCircle, perms: ['tasks:create'], section: 'Work' },
  { label: 'Scheduled Tasks', to: '/tasks/schedules', icon: Repeat, perms: ['schedules:view'], section: 'Work' },
  { label: 'Projects', to: '/tasks/projects', icon: FolderKanban, perms: ['projects:view'], section: 'Work' },
  { label: 'Outlet Tasks', to: '/tasks/outlet-tasks', icon: ListChecks, perms: ['tasks:view'], section: 'Operations' },
  { label: 'Outlets', to: '/tasks/outlets', icon: Store, perms: ['outlets:view'], section: 'Operations' },
  { label: 'Issues', to: '/tasks/issues', icon: TriangleAlert, perms: ['issues:view'], section: 'Operations' },
  { label: 'Calendar', to: '/tasks/calendar', icon: CalendarRange, perms: ['calendar:view'], section: 'Operations' },
  { label: 'Reports', to: '/tasks/reports', icon: BarChart3, perms: ['task_reports:view'], section: 'Insights' },
  { label: 'Categories & Templates', to: '/tasks/setup', icon: Tags, perms: ['task_categories:view'], section: 'Administration' },
  { label: 'Settings', to: '/settings', icon: Settings, perms: ['settings:view'], section: 'Administration' },
  { label: 'Audit Logs', to: '/audit-logs', icon: ScrollText, perms: ['audit:view'], section: 'Administration' },
];

export const MODULES: { id: ModuleId; label: string; home: string; nav: NavItem[]; icon: LucideIcon }[] = [
  { id: 'hrms', label: 'HRMS', home: '/hrms/dashboard', nav: HRMS_NAV, icon: UserCog },
  { id: 'tasks', label: 'Tasks', home: '/tasks/dashboard', nav: TASK_NAV, icon: ListChecks },
];
